'use strict';

var React = require('react');

var SvgMarketsRupeeFilledIcon = function SvgMarketsRupeeFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3 10a7 7 0 0 1 13.54-2.5h-3.79c-.469 0-.9.161-1.24.431l.058-.234c.068-.27.22-.5.425-.667l.007-.03h.03c.212-.158.473-.25.75-.25h.22a.75.75 0 0 0 .75-.75v-.023a5.502 5.502 0 0 0-9.174 3.107l.276.183a.75.75 0 0 0 1.016-.174l.262-.35a.75.75 0 0 1 1.334.303l.103.515a.857.857 0 0 0 1.554.307l.374-.561a1.25 1.25 0 0 1 1.04-.557h.184a.75.75 0 0 0 .186-.023 1.991 1.991 0 0 0 .284 2.023 1.991 1.991 0 0 0-.439 1.25c0 .533.208 1.017.548 1.375h-.37c-.466 0-.905.22-1.185.592-.165.22-.384.395-.635.506l-1.294.575a5.51 5.51 0 0 0 3.731.232c.163.364.44.694.843.941l.357.22a7 7 0 0 1-9.745-6.441Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.889 16.643a.75.75 0 0 0-.246-1.032l-1.713-1.054a2.486 2.486 0 0 0 1.059-1.807h1.261a.75.75 0 0 0 0-1.5h-1.25v-1h1.25a.75.75 0 0 0 0-1.5h-4.5a.75.75 0 0 0 0 1.5h1.75v1h-1.75a.75.75 0 0 0 0 1.5h1.721a.989.989 0 0 1-.96.75c-.901 0-1.237 1.184-.468 1.657l2.814 1.732a.75.75 0 0 0 1.032-.246Z"
  }));
};
SvgMarketsRupeeFilledIcon.displayName = "MarketsRupeeFilledIcon";

exports.SvgMarketsRupeeFilledIcon = SvgMarketsRupeeFilledIcon;
